import { apiGet, apiGetList, apiPost, apiPut } from "services/api";

export const CLIENTS_PAGE_SIZE = 200;

/* --- Группы клиентов --- */

export const getClientGroups = () =>
  apiGetList("users/client-groups", { page: 1, pageSize: 500 });

export const createClientGroup = (payload) =>
  apiPost("users/client-group", payload);

export const updateClientGroup = (payload) =>
  apiPut("users/client-group", payload);

export const deleteClientGroup = (clientgroupid) =>
  apiPost("users/delete-client-group", {
    clientgroupid: Number(clientgroupid),
  });

/* --- Клиенты --- */

export const getClients = ({
  page = 1,
  pageSize = CLIENTS_PAGE_SIZE,
  clientgroupid,
  search,
} = {}) =>
  apiGetList("users/clients", {
    page,
    pageSize,
    clientgroupid,
    ...(search ? { search } : {}),
  });

export const createClient = (payload) => apiPost("users/client", payload);

export const updateClient = (payload) => apiPut("users/client", payload);

export const deleteClient = (clientid) =>
  apiPost("users/delete-client", { clientid: Number(clientid) });

/* --- Лицевой счёт --- */

export const getClientAccount = (clientid) =>
  apiGet("users/client-account", { clientid });

export const updateClientAccount = (payload) =>
  apiPut("users/client-account", payload);

/* --- Скидки по группам товаров --- */

export const getDiscountItemGroups = (clientid) =>
  apiGetList("users/discount-itemgroup", { clientid, page: 1, pageSize: 100 });

export const createDiscountItemGroup = (payload) =>
  apiPost("users/discount-itemgroup", payload);

export const deleteDiscountItemGroup = (clientdiscountitemgroupid) =>
  apiPost("users/delete-discountitemgroup", {
    clientdiscountitemgroupid: Number(clientdiscountitemgroupid),
  });

/* --- Транзакции бонусов --- */

export const getClientTransactions = (clientid) =>
  apiGetList("users/get-transactions", { clientid });

export const createClientTransaction = ({ total, comment, clientid, action }) =>
  apiPost("users/client-transaction", {
    total: Number(total),
    comment,
    clientid: Number(clientid),
    action,
  });

export const deleteClientTransaction = (clienttransactionid) =>
  apiPost("users/delete-transactions", {
    clienttransactionid: Number(clienttransactionid),
  });

export const getTransactionCalculation = (clientid) =>
  apiGet("users/transaction-calculation", { clientid });

/* --- Знаменательные даты --- */

export const getClientDates = (clientid) =>
  apiGetList("users/client-date", { clientid });

export const createClientDate = (payload) =>
  apiPost("users/client-date", payload);

export const deleteClientDate = (clientdateid) =>
  apiPost("users/delete-date", { clientdateid: Number(clientdateid) });
